import { createSlice } from "@reduxjs/toolkit";
import { fetchApplication } from "../thunks/fetch-application-thunk";
import { postApplication } from "../thunks/post-application-thunk";
import { uploadSlice } from "./upload-slice";
const initialState = {
    // application: {
    //     App_REQID: '',
    //     References: '',
    //     SignatureDate: ''
    // },
    application: [],
    recentApplication: {},
    status: "idle",
    postStatus: "idle",
    error: null,
    postError: null,
};

export const applicationSlice = createSlice({
    name: "application",
    initialState,
    reducers: {
        resetApplications: (state) => {
            state.application = [];
            state.recentApplication = {}
        },
        resetPost: (state) => {
            state.postStatus = "idle";
            state.postError = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchApplication.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchApplication.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.application = action.payload.reverse();
                
                function formatDateToInputFormat(dateString) {
                    if (!dateString) {
                        return "";
                    }

                    const parts = dateString.split("/");
                    
                    if (parts.length < 3) {
                        return parts;
                    }

                    const [month, day, year] = parts;
                    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
                }

                if(state.application.length > 0) {
                    state.recentApplication = state.application[0]
                    state.recentApplication.Trainings1_From = formatDateToInputFormat(state.recentApplication.Trainings1_From) 
                    state.recentApplication.Trainings1_To = formatDateToInputFormat(state.recentApplication.Trainings1_To) 
                    state.recentApplication.Trainings1_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings1_ExpirationDate) 

                    state.recentApplication.Trainings2_From = formatDateToInputFormat(state.recentApplication.Trainings2_From) 
                    state.recentApplication.Trainings2_To = formatDateToInputFormat(state.recentApplication.Trainings2_To) 
                    state.recentApplication.Trainings2_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings2_ExpirationDate) 

                    state.recentApplication.Trainings3_From = formatDateToInputFormat(state.recentApplication.Trainings3_From) 
                    state.recentApplication.Trainings3_To = formatDateToInputFormat(state.recentApplication.Trainings3_To) 
                    state.recentApplication.Trainings3_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings3_ExpirationDate) 

                    state.recentApplication.Trainings4_From = formatDateToInputFormat(state.recentApplication.Trainings4_From) 
                    state.recentApplication.Trainings4_To = formatDateToInputFormat(state.recentApplication.Trainings4_To) 
                    state.recentApplication.Trainings4_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings4_ExpirationDate) 

                    state.recentApplication.Trainings5_From = formatDateToInputFormat(state.recentApplication.Trainings5_From) 
                    state.recentApplication.Trainings5_To = formatDateToInputFormat(state.recentApplication.Trainings5_To) 
                    state.recentApplication.Trainings5_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings5_ExpirationDate) 

                    state.recentApplication.Trainings6_From = formatDateToInputFormat(state.recentApplication.Trainings6_From) 
                    state.recentApplication.Trainings6_To = formatDateToInputFormat(state.recentApplication.Trainings6_To) 
                    state.recentApplication.Trainings6_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings6_ExpirationDate) 

                }
            })
            .addCase(fetchApplication.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(postApplication.pending, (state) => {
                state.postStatus = "loading";
            })
            .addCase(postApplication.fulfilled, (state, action) => {
                state.postStatus = "succeeded";
                // state.application = [action.payload.data, ...state.application.application];
                state.application.unshift(action.payload.data);

                function formatDateToInputFormat(dateString) {
                    if (!dateString) {
                        return "";
                    }

                    const parts = dateString.split("/");
                    
                    if (parts.length < 3) {
                        return parts;
                    }

                    const [month, day, year] = parts;
                    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
                }

                if(action.payload.data) {
                    state.recentApplication = action.payload.data
                    state.recentApplication.Trainings1_From = formatDateToInputFormat(state.recentApplication.Trainings1_From) 
                    state.recentApplication.Trainings1_To = formatDateToInputFormat(state.recentApplication.Trainings1_To) 
                    state.recentApplication.Trainings1_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings1_ExpirationDate) 

                    state.recentApplication.Trainings2_From = formatDateToInputFormat(state.recentApplication.Trainings2_From) 
                    state.recentApplication.Trainings2_To = formatDateToInputFormat(state.recentApplication.Trainings2_To) 
                    state.recentApplication.Trainings2_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings2_ExpirationDate) 

                    state.recentApplication.Trainings3_From = formatDateToInputFormat(state.recentApplication.Trainings3_From) 
                    state.recentApplication.Trainings3_To = formatDateToInputFormat(state.recentApplication.Trainings3_To) 
                    state.recentApplication.Trainings3_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings3_ExpirationDate) 

                    state.recentApplication.Trainings4_From = formatDateToInputFormat(state.recentApplication.Trainings4_From) 
                    state.recentApplication.Trainings4_To = formatDateToInputFormat(state.recentApplication.Trainings4_To) 
                    state.recentApplication.Trainings4_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings4_ExpirationDate) 

                    state.recentApplication.Trainings5_From = formatDateToInputFormat(state.recentApplication.Trainings5_From) 
                    state.recentApplication.Trainings5_To = formatDateToInputFormat(state.recentApplication.Trainings5_To) 
                    state.recentApplication.Trainings5_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings5_ExpirationDate) 

                    state.recentApplication.Trainings6_From = formatDateToInputFormat(state.recentApplication.Trainings6_From) 
                    state.recentApplication.Trainings6_To = formatDateToInputFormat(state.recentApplication.Trainings6_To) 
                    state.recentApplication.Trainings6_ExpirationDate = formatDateToInputFormat(state.recentApplication.Trainings6_ExpirationDate) 
                }
            })
            .addCase(postApplication.rejected, (state, action) => {
                state.postStatus = "failed";
                state.postError = action.error.message;
            });
    },
});

export const selectApplication = (state) => state.application.application;
export const selectRecentApplication = (state) => state.application.recentApplication;
export const selectPostError = (state) => state.application.postError;
export const selectPostStatus = (state) => state.application.postStatus;
export const { resetPost, resetApplications } = applicationSlice.actions;
